export default __webpack_public_path__ + "static/media/search.acde07ab.svg";